import {STATUS} from '@jobseeker/common-core/constants';
import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';
import qs from 'qs';

import type {OtpBodyType, ResponseOtp} from './types';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_ANGLE_BIDDER_API_HOST}${process.env.NEXT_PUBLIC_ANGLE_BIDDER_API_VERSION}/`
);

const sendOtp = async (
  path: string,
  token: string,
  otpBody: OtpBodyType
): Promise<ResponseOtp> => {
  try {
    if (!token) {
      return {
        error: {
          message: 'Try again!',
          code: 0,
        },
      };
    }
    const response: any = await axios.post(`${path}`, qs.stringify(otpBody), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: false,
    });
    if (response[STATUS] === 200) {
      if (response['data']['status']['success']) {
        return {
          otpSent: true,
        };
      }

      if (response['data']['status']['error']) {
        return {
          error: {
            message: response['data']['status']?.['errorMsg'],
            code: response['data']['status']?.['code'],
          },
        };
      }
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data.error.message,
        code: error.response?.data.error.statusCode,
      },
    };
  }
};

const verifyOtp = async (
  path: string,
  token: string,
  otpBody: OtpBodyType
): Promise<ResponseOtp> => {
  try {
    if (!token) {
      return {
        error: {
          message: 'Try again!',
          code: 0,
        },
      };
    }
    const response: any = await axios.post(`${path}`, qs.stringify(otpBody), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: false,
    });

    if (response[STATUS] === 200) {
      if (response['data']['status']?.['success']) {
        return {
          otpVerified: true,
          key: response['data']?.['data']?.['en_cookie'],
        };
      }

      if (response['data']['status']?.['error']) {
        return {
          error: {
            message: response['data']['status']?.['errorMsg'],
            code: response['data']['status']?.['code'],
          },
        };
      }
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data.error.message,
        code: error.response?.data.error.statusCode,
      },
    };
  }
};

const mfaService = {
  sendOtp,
  verifyOtp,
};

export default mfaService;
